import {z} from "zod";

const schema = z.object({
	id: z.string().nullable(),
	name: z.string().nullable(),
	accessible: z.boolean().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantNameModel = {schema, model};
export type ITaxAccountantNameModel = z.infer<typeof TaxAccountantNameModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_NAME: ITaxAccountantNameModel = {
	id: "",
	name: "",
	accessible: false
};
